// cSpell:ignore Afrekening Eindafrekening vertrek
import { getLocalizedText } from "../../../utils/i18n/i18n.utils";
import { getSettlementTitle } from "../../../utils/settlement.utils";
import { stringToSnakeCase } from "../../../utils/string.utils";
var LABEL_SEPARATOR = " — ";
// The subject of a cost or settlement activity. A cost names its supplier and
// its category: the category in the reader's language, or the broker's own
// wording for an "Other" cost. A settlement is named by the name the broker
// gave it (the row's label, Lewis 2026-10-16), else by its kind and period
// ("Afrekening 2026", "Eindafrekening bij vertrek"; getSettlementTitle); a
// row without a kind reads as a regular settlement. Other older rows carry a
// ready-made label only.
export var getActivityLabel = function (params) {
    var label = params.label, costCategory = params.costCategory, costCategoryOther = params.costCategoryOther, settlementKind = params.settlementKind, settlementPeriodFrom = params.settlementPeriodFrom, settlementPeriodTo = params.settlementPeriodTo;
    if (costCategory) {
        var category = costCategoryOther ||
            getLocalizedText("costs.category.".concat(stringToSnakeCase(costCategory)));
        return [label, category].filter(Boolean).join(LABEL_SEPARATOR);
    }
    if (settlementPeriodFrom && settlementPeriodTo) {
        return ((label === null || label === void 0 ? void 0 : label.trim()) ||
            getSettlementTitle({
                kind: settlementKind === "departure" ? "departure" : "regular",
                from: settlementPeriodFrom,
                to: settlementPeriodTo,
            }));
    }
    return label || "invalid label";
};
